import { PRODUCT_BULK_POLICY_LIMIT as PRODUCT_BULK_SELECTION_LIMIT } from "@price-rescue/domain/product-bulk-actions";

export function freezeProductBulkSelection(productIds: string[]): string[] {
  const selection = [...new Set(productIds)];
  if (
    selection.length === 0 ||
    selection.length > PRODUCT_BULK_SELECTION_LIMIT ||
    selection.some((id) => !id.trim())
  ) {
    throw new Error(
      `Select between 1 and ${PRODUCT_BULK_SELECTION_LIMIT} products from the current page.`,
    );
  }
  return selection;
}
